module.exports = __webpack_public_path__ + "assets/img/143.cff78020.png";